(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-urgencia-escasez"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarRotacionMensajes(contenedor) {
    var itemsMensajes = contenedor.querySelectorAll('.cl-urgencia-mensaje-item');
    if (itemsMensajes.length < 2 || contenedor.dataset.rotar !== 'true') {
      return;
    }
    var intervaloMs = parseInt(contenedor.dataset.intervalo, 10) * 1000;
    if (!intervaloMs || intervaloMs < 500) {
      intervaloMs = 4000;
    }
    var indiceActual = 0;
    setInterval(function () {
      itemsMensajes[indiceActual].classList.remove('cl-urgencia-mensaje-activo');
      indiceActual = (indiceActual + 1) % itemsMensajes.length;
      itemsMensajes[indiceActual].classList.add('cl-urgencia-mensaje-activo');
    }, intervaloMs);
  }

  function formatearDosDigitos(numero) {
    return numero < 10 ? '0' + numero : String(numero);
  }

  function iniciarTemporizador(contenedorTemporizador) {
    var idSeccion = contenedorTemporizador.dataset.id;
    var horas = parseFloat(contenedorTemporizador.dataset.horas);
    if (!horas || horas <= 0) {
      horas = 24;
    }
    var reiniciar = contenedorTemporizador.dataset.reiniciar === 'true';
    var claveAlmacenamiento = 'cl_urgencia_fin_' + idSeccion;
    var duracionMs = horas * 60 * 60 * 1000;
    var tiempoFin;

    if (reiniciar) {
      tiempoFin = Date.now() + duracionMs;
    } else {
      var tiempoGuardado = null;
      try {
        tiempoGuardado = window.localStorage.getItem(claveAlmacenamiento);
      } catch (error) {
        tiempoGuardado = null;
      }
      if (tiempoGuardado && parseInt(tiempoGuardado, 10) > Date.now()) {
        tiempoFin = parseInt(tiempoGuardado, 10);
      } else {
        tiempoFin = Date.now() + duracionMs;
        try {
          window.localStorage.setItem(claveAlmacenamiento, String(tiempoFin));
        } catch (error) {}
      }
    }

    var elementoHoras = contenedorTemporizador.querySelector('[data-horas-valor]');
    var elementoMinutos = contenedorTemporizador.querySelector('[data-minutos-valor]');
    var elementoSegundos = contenedorTemporizador.querySelector('[data-segundos-valor]');

    function actualizar() {
      var restante = tiempoFin - Date.now();
      if (restante <= 0) {
        if (reiniciar) {
          tiempoFin = Date.now() + duracionMs;
          restante = tiempoFin - Date.now();
        } else {
          restante = 0;
        }
      }
      var horasRestantes = Math.floor(restante / (1000 * 60 * 60));
      var minutosRestantes = Math.floor((restante % (1000 * 60 * 60)) / (1000 * 60));
      var segundosRestantes = Math.floor((restante % (1000 * 60)) / 1000);
      elementoHoras.textContent = formatearDosDigitos(horasRestantes);
      elementoMinutos.textContent = formatearDosDigitos(minutosRestantes);
      elementoSegundos.textContent = formatearDosDigitos(segundosRestantes);
    }

    actualizar();
    setInterval(actualizar, 1000);
  }

  document.querySelectorAll('.cl-urgencia-mensajes').forEach(iniciarRotacionMensajes);
  document.querySelectorAll('.cl-urgencia-temporizador').forEach(iniciarTemporizador);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
